/**
 * @generated SignedSource<<792d7ce061cf37d47820a0bef282e236>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsDetailsPage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly components: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly components?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly __typename: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ArchiveList_component" | "BaseData_component" | "FundsIntroduction_component" | "PerformanceByYear_component" | "PerformanceOverview_component" | "TrancheSelection_component" | "Widget_component">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly largeinvestmentfonds: number | null | undefined;
  readonly path: string | null | undefined;
  readonly reportcurrency: string | null | undefined;
  readonly " $fragmentType": "FundsDetailsPage_page";
};
export type FundsDetailsPage_page$key = {
  readonly " $data"?: FundsDetailsPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsDetailsPage_page">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "salesAdmission",
  "variableName": "salesAdmission"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesAdmission"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsDetailsPage_page",
  "selections": [
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "ComponentConnection",
      "kind": "LinkedField",
      "name": "components",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ArchiveList_component"
                },
                {
                  "args": [
                    (v3/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "BaseData_component"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PerformanceOverview_component"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PerformanceByYear_component"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FundsIntroduction_component"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TrancheSelection_component"
                },
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "componentsCount",
                      "value": 10000
                    },
                    (v3/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "Widget_component"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": (v0/*: any*/),
                      "concreteType": "ComponentConnection",
                      "kind": "LinkedField",
                      "name": "components",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ComponentEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v2/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "components(first:10000)"
                    }
                  ],
                  "type": "Widget",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "components(first:10000)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largeinvestmentfonds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportcurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "FundsDetailsPage",
  "abstractKey": null
};
})();

(node as any).hash = "6b012cd41e93e8586848382642c93f20";

export default node;
